<style lang="scss" scoped>
.header-custome {
  margin-bottom: 15px;
  padding-left: 2px;
}
.tab-action-btn-fill-conatiner.con-vs-tabs .vs-tabs--content {
  padding: 0 10px 23px !important;
}
.image-wrap-add-edit {
  width: 180px;
  height: 36px;
  border: 1px solid #dfdfdf;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
.image-wrap-add-edit img {
  max-width: 100%;
  max-height: 100%;
}
.checkout-form-custom-wraper .md {
  display: block !important;
}
.custom-checkout-form {
  margin: 0 100px;
  position: relative;
}

.paying-logo-wrap .paying-logo-image-wrap img {
  width: 100%;
  height: auto;
}
.preview-form {
  position: absolute;
  top: 12px;
  right: 26px;
}
@media only screen and (min-width: 1367px) and (max-width: 1440px) {
  .custom-checkout-form {
    margin: 0 0px;
  }
}
@media only screen and (max-width: 1366px) {
  .custom-checkout-form {
    margin: 0;
  }
}
</style>
<style>
.custom-checkout-form .v-select .vs__dropdown-toggle {
  height: 42px !important;
  background: #fff !important;
}

/* .pre-sign-up-terms-wrap {height: 560px;} */
/* .textarea-custom {height: 560px; background: #fff;} */
.textarea-custom textarea {
  height: 100%;
}
.textbox-beside-wrap textarea {
  background: #fff;
}
.field-select-dropdown {
  width: 200px;
  position: absolute;
  right: 0;
  bottom: 0;
}
.add-new-row {
  position: relative;
  background: #fff;
  padding: 20px 0;
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  border: 2px dashed #b9b9b9;
}
.form-option ul {
  margin: 0;
  padding: 0;
}
.form-option ul li {
  display: inline;
  font-weight: 600;
  color: #000;
  font-size: 18px;
  margin-right: 15px;
}
.form-option ul li:last-child {
  margin-right: 0;
}
.add-new-row h5 {
  font-weight: 500;
  font-size: 22px;
  color: #000;
}
.custom-checkout-form label {
  color: #000;
  font-weight: 500;
}
.delete-field-button {
  position: absolute;
  top: 5px;
  right: 5px;
}
.field-width-slider-wrap {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.single-slider {
  width: 300px;
}
.box {
  background: #4c8bf6;
  display: inline-block;
  padding: 0px 12px;
  line-height: 21px;
  border-radius: 50px;
  font-size: 14px;
  color: #fff;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.4);
}
.custom-card {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.2);
}
.checkout-form-custom-wraper .wizard-tab-content {
  width: 100%;
}
.custom-checkout-form.vue-form-wizard .wizard-tab-content {
  padding: 0 !important;
}
.single-dragable-field input.vs-inputx.vs-input--input.normal.hasValue {
  height: 42px;
  border-radius: 5px !important;
}
</style>
<template>
  <div class="vx-row checkout-form-custom-wraper">
    <div class="vx-col md:w-1/1 w-full">
      <form-wizard
        class="custom-checkout-form"
        color="rgba(var(--vs-primary), 1)"
        :title="this.$route.params.FormId ? 'Edit Form' : 'Create Form'"
        :subtitle="null"
        :startIndex="activeWizard"
        finishButtonText="Submit"
        @on-complete="SaveCheckoutForm(false)"
        layout="vertical"
      >
        <div class="preview-form">
          <vs-button
            color="primary"
            type="filled"
            icon-pack="feather"
            icon="icon-external-link"
            @click="savePreview"
            >Save & Preview</vs-button
          >
        </div>
        <tab-content
          title="Form Builder"
          class="mb-5"
          :before-change="before_save"
        >
          <vs-tabs>
            <vs-tab label="Basic fileds">
              <div class="tab-text">
                <div class="vx-row">
                  <div class="vx-col md:w-6/12 w-full">
                    <div class="checkout-top-label">
                      <label class="w-full">Form Title</label>
                      <vs-input
                        class="w-full"
                        name="FormTitle"
                        v-model="FormTitle"
                        v-validate="'required'"
                      />
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('FormTitle')"
                        >{{ errors.first("FormTitle") }}</span
                      >
                    </div>
                  </div>

                  <div class="vx-col md:w-6/12 w-full">
                    <div class="check-out-top-label">
                      <label class="w-full">Map to Registration Type(s)</label>
                      <v-select
                        class="w-full"
                        multiple
                        label="RegistrationType"
                        v-model="RegistrationTypes"
                        name="RegistrationTypes"
                        :options="TicketList"
                        v-validate="'required'"
                        @input="$validator.validate()"
                      />
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('RegistrationTypes')"
                        >{{ errors.first("RegistrationTypes") }}</span
                      >
                    </div>
                  </div>
                </div>
                <draggable
                  :list="DefaultFields"
                  :group="{ name: 'tags', pull: 'clone', put: false }"
                >
                  <vx-card
                    class="mt-5 cursor-move w-full single-dragable-field"
                    v-for="(field, findex) in DefaultFields"
                  >
                    <div class="vx-row">
                      <div class="delete-field-button">
                        <vs-button
                          v-show="!field.StaticField"
                          class="ml-5"
                          icon-pack="feather"
                          icon="icon-x"
                          color="danger"
                          size="small"
                          type="gradient"
                          @click="DefaultFields.splice(findex, 1)"
                        ></vs-button>
                      </div>
                      <div class="vx-col w-full md:w-3/12 mb-3">
                        <label class="w-full">Field Type</label>
                        <v-select
                          class="w-full"
                          :clearable="false"
                          :disabled="field.StaticField ? true : false"
                          v-model="field.Type"
                          label="Name"
                          :options="inputFields"
                          :selectable="(item) => !item.IsDisabled"
                          :reduce="(item) => item.Value"
                          @input="setFieldType(field, findex)"
                        />
                      </div>
                      <!-- <div class="vx-col w-full md:w-4/12 mb-3" v-if="!['profilepicture','country&state'].includes(field.Type)">
                          <label class="w-full">Field Name</label>
                          <vs-input
                            class="w-full"
                            :name="field.FieldId"
                            v-model="field.Name"
                            v-validate="'required'"
                          />   
                          <span class="text-danger text-sm" v-show="errors.has(field.FieldId)">This is required</span>                      
                        </div> -->
                      <div
                        class="vx-col w-full md:w-4/12 mb-3"
                        v-if="!['country&state'].includes(field.Type)"
                      >
                        <label class="w-full"
                          >Display Label<span class="text-danger">*</span>
                          (Attendees would see this)</label
                        >
                        <vs-input
                          class="w-full"
                          v-model="field.Label"
                          @blur="setFieldName(field, findex)"
                          :name="`Label${findex}`"
                          v-validate="'required'"
                        />
                        <span
                          class="text-danger text-sm"
                          v-show="errors.has('Label' + findex)"
                          >This field is required</span
                        >
                      </div>
                      <div
                        class="vx-col w-full md:w-4/12 mb-3"
                        v-if="
                          !['profilepicture', 'country&state', 'file'].includes(
                            field.Type
                          )
                        "
                      >
                        <label class="w-full"
                          >PlaceHolder Text (Instructions to fill-up)</label
                        >
                        <vs-input class="w-full" v-model="field.PlaceHolder" />
                      </div>
                      <div
                        class="vx-col w-full md:w-4/12 mb-3"
                        v-if="['file'].includes(field.Type)"
                      >
                        <label class="w-full">Max File Size(Mb)</label>
                        <vs-input class="w-full" v-model="field.MaxSize" />
                      </div>
                      <div
                        class="vx-col w-full md:w-4/12 mb-3"
                        v-if="['file'].includes(field.Type)"
                      >
                        <label class="w-full">Allowed Formats</label>
                        <v-select
                          multiple
                          v-model="field.Formats"
                          :options="FileUploadFormats"
                          label="Types"
                          name="FileTypeList"
                        />
                      </div>
                      <div
                        class="vx-col w-full md:w-4/12 mb-3"
                        v-if="['file'].includes(field.Type)"
                      >
                        <label class="w-full">File Category</label>
                        <v-select
                          v-model="field.Category"
                          :options="FileUploadCategory"
                          label="Category"
                          name="FileCategoryList"
                        />

                      </div>
                      <!-- <div class="vx-col w-full md:w-3/12 mb-3">
                          <label class="w-full md:w-2/12">Field Order</label>
                          <vs-input-number
                            class="w-full md:w-10/12"
                            v-model="field.Order"
                            min="1"
                          />                        
                        </div> -->                        
                      <div class="vx-col w-full md:w-2/12" v-if="['email'].includes(field.Type)">
                        <div
                          class="mt-8"
                          style="
                            display: flex;
                            justify-content: flex-start;
                            align-items: center;
                          "
                        >
                          <label>Compare?</label>
                          <vs-switch class="ml-5" v-model="field.Compare" @change="setColumnSizeFixed(field)" />
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-2/12">
                        <div
                          class="mt-8"
                          style="
                            display: flex;
                            justify-content: flex-start;
                            align-items: center;
                          "
                        >
                          <label>Required?</label>
                          <vs-switch class="ml-5" v-model="field.Mandatory" />
                        </div>
                      </div>

                      <!-- <div class="vx-col w-full md:w-3/12 mb-3">
                          <label class="w-full md:w-2/12">Show In Visitor Form</label>
                          <vs-switch
                            class="w-full md:w-2/12 mt-3"
                            v-model="field.ShowInVisitor"
                          />                        
                        </div> -->
                      <div class="vx-col w-full md:w-5/12 mb-3">
                        <label class="w-full md:w-2/12">Field Width</label>
                        <!-- <v-select
                            class="w-full"
                            :clearable="false"
                            v-model="field.ColumnSize"
                            :options="[1,2,3,4,5,6,7,8,9,10,11,12]"
                          />                        -->
                        <div class="field-width-slider-wrap">
                          <div class="single-slider">
                            <vs-slider
                              :min="1"
                              :max="12"
                              ticks
                              color="#4c8bf6"
                              v-model="field.ColumnSize"
                              :disabled="field.Compare"
                            />
                          </div>
                          <div class="box ml-3">{{ field.ColumnSize }}</div>
                        </div>
                      </div>
                      <div
                        class="vx-col w-full md:w-5/12 mt-5"
                        v-if="
                          [
                            'radio',
                            'select',
                            'multiselect',
                            'Salutation',
                          ].includes(field.Type)
                        "
                      >
                        <div class="vx-row d-flex items-center">
                          <label class="vx-col"><u>Options</u></label>
                          <vs-button
                            class="vx-col"
                            size="small"
                            color="primary"
                            type="border"
                            radius
                            icon="add"
                            @click="field.Options.push(null)"
                          ></vs-button>
                        </div>
                        <div
                          class="vx-row w-full"
                          v-for="(optionVal, index) in field.Options"
                        >
                          <vs-input
                            class="vx-col w-full mt-2"
                            v-model="field.Options[index]"
                          />
                          <vs-button
                            class="vx-col mt-2"
                            size="small"
                            color="danger"
                            type="border"
                            radius
                            icon="delete"
                            @click="field.Options.splice(index, 1)"
                          ></vs-button>
                        </div>
                      </div>
                    </div>
                  </vx-card>
                </draggable>
                <div class="vx-col w-full md:w-1/1 my-8">
                  <div class="add-new-row" align="center">
                    <!-- <div class="mb-5 form-option">
                        <ul>
                          <li><vs-radio v-model="FieldsType" vs-value="Basic">Basic</vs-radio></li>
                          <li><vs-radio v-model="FieldsType" vs-value="Dynamic">Dynamic</vs-radio></li>
                        </ul>
                      </div> -->
                    <div class="row-add-button" align="center">
                      <vs-button
                        color="primary"
                        type="border"
                        class="flex items-center"
                        icon-pack="feather"
                        icon="icon-plus"
                        @click="addRow(0)"
                      >
                        Add New Field
                      </vs-button>
                    </div>
                  </div>
                </div>
              </div>
            </vs-tab>
            <!-- <vs-tab label="Custom fields">
                <div class="tab-text">
                  <div class="vx-row">
                    <div class="vx-col md:w-4/12 w-full h-100">
                      <div class="textbox-beside-wrap">
                        <h4>Custom Fields</h4>
                      </div>
                    </div>
                    <div class="vx-col md:w-3/12 w-full h-100"></div>
                    <div class="vx-col md:w-3/12 w-full h-100"></div>
                    <div class="vx-col md:w-4/12 w-full h-100">
                      <div class="textbox-beside-wrap"></div>
                    </div>
                  </div>
                  <br />
                    DYNAMIC FORM BUILDER STARTS
                    <form data-vv-scope="step-2" class="dynamic-from-wrap">
                      <div class="vx-row">                        
                        <div class="w-full">
                          <q-form-builder
                            v-model="DynamicFields"
                            :source-fields="mySourceFields"
                          />
                        </div>
                      </div>
                      <div class="vx-row">
                        <div class="w-full">
                          <q-separator />
                        </div>
                      </div>
                    </form>                    
                </div>
              </vs-tab> -->
          </vs-tabs>
        </tab-content>
        <tab-content title="Pre Signup" class="mb-5">
          <div class="vx-row">
            <div class="vx-col w-full md:w-12/12">
              <div class="pre-sign-up-terms-wrap">
                <label class="mr-4">Pre-sign up Terms &amp; Conditions</label>
                <ckeditor
                  class="w-full textarea-custom"
                  name="PreSignupTermsHtml"
                  v-model="PreSignupFields.HTMLbody"
                  data-vv-as="PreSignupTerms Html"
                  :config="editorConfig"
                ></ckeditor>
                <!-- <vs-textarea
                    class="w-full textarea-custom"
                    name="PreSignupTermsHtml"
                    v-model="PreSignupFields.HTMLbody"
                    data-vv-as="PreSignupTerms Html"
                  /> -->
              </div>
            </div>
          </div>

          <br />
          <div class="custom-card mt-12">
            <div class="vx-row">
              <div class="vx-col w-full md:w-12/12">
                <div class="vx-row">
                  <div class="vx-col md:w-6/12">
                    <label>Acceptance Validation Display Label </label>

                    <div class="textbox-beside-wrap">
                      <vs-textarea
                        class="w-full"
                        name="AcceptanceValidationDisplayLabel"
                        v-model="
                          PreSignupFields.AcceptanceValidationDisplayLabel
                        "
                        data-vv-as="MailingAddress Label"
                      />
                    </div>
                    <div class="check-accept-wrap">
                      <vs-checkbox v-model="PreSignupFields.RequireAcceptance"
                        >Required?</vs-checkbox
                      >
                    </div>
                  </div>
                  <div class="vx-col md:w-6/12">
                    <label>Acceptance Display Text </label>
                    <div class="textbox-beside-wrap">
                      <vs-textarea
                        class="w-full"
                        name="AcceptanceDisplayText"
                        v-model="PreSignupFields.AcceptanceDisplayText"
                        data-vv-as="Acceptance Display Text"
                      />
                    </div>
                  </div>
                  <!-- <div class="vx-col md:w-12/12 mt-10">
                        
                      </div> -->
                  <div class="vx-col w-full md:w-12/12 mt-4">
                    <div class="textbox-beside-wrap pre-signup-option-wrap">
                      <label>Opt-in 1 text</label>
                      <vs-input
                        class="w-full"
                        name="OptInOne"
                        v-model="PreSignupFields.OptInOne"
                        data-vv-as="OptInOne"
                      />
                      <vs-checkbox
                        class="mt-3"
                        v-model="PreSignupFields.OptInOneIsRequired"
                        >Required?</vs-checkbox
                      >
                    </div>
                  </div>
                  <div class="vx-col w-full md:w-12/12 mt-4">
                    <div class="textbox-beside-wrap pre-signup-option-wrap">
                      <label>Opt-in 2 text </label>
                      <vs-input
                        class="w-full"
                        name="OptInTwo"
                        v-model="PreSignupFields.OptInTwo"
                        data-vv-as="OptInTwo"
                      />
                      <vs-checkbox
                        class="mt-3"
                        v-model="PreSignupFields.OptInTwoIsRequired"
                        >Required?</vs-checkbox
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </tab-content>

        <template slot="footer" scope="props">
          <div class="wizard-footer-left">
            <vs-button
              v-if="props.activeTabIndex == 0"
              @click.native="$router.push('/event/reg-dashboard?activeTab=1')"
              >Back to List</vs-button
            >
            <vs-button @click.native="props.prevTab()" v-else
              >Previous</vs-button
            >
          </div>
          <div class="wizard-footer-right">
            <vs-button
              v-if="props.activeTabIndex == 0"
              @click.native="props.nextTab()"
              :disabled="!validateForm"
              class="wizard-footer-right ml-4"
              color="success"
              >Next</vs-button
            >
            <vs-button
              v-if="props.isLastStep"
              @click.native="SaveCheckoutForm(false)"
              :disabled="!validateForm"
              class="wizard-footer-right finish-button"
              color="success"
              >Save &amp; Exit</vs-button
            >
          </div>
        </template>
      </form-wizard>
    </div>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";
import moment from "moment-timezone";
import axios from "@/axios.js";
import draggable from "vuedraggable";
import con from "@/firebase/firebaseInit.ts";
import CKEditor from "ckeditor4-vue";
import CKconfig from "@/assets/ckeditor-config.ts";

import ls from "@/common/localStorage";
let clientId = ls.getSessionValueByKey("Session_Client_Id");
let eventId = ls.getSessionValueByKey("Session_Event_Id");
var eventID = ls.getSessionValueByKey("Session_Event_Id");
var vm;
//---------------------------------------------------------------
import moduleTicketManagement from "@/store/ticket-management/moduleTicketManagement.js";

let storageRef = con.storageRef;
var cn = ls.getSessionEventCollectionName();
/*import "q-form-builder/dist/css/app.6f06bd74.css";
import QFormBuilder from "../form-builder/QFormBuilder";*/

export default {
  components: {
    FormWizard,
    TabContent,
    vSelect,
    quillEditor,
    //QFormBuilder,
    draggable,
    ckeditor: CKEditor.component,
  },
  computed: {
    inputFields() {
      let vm = this;
      let predefinedInputs = this.predefinedInputs.map((pdf) => {
        let found = vm.DefaultFields.some((df) => df.Type == pdf.Value);
        if (found) pdf.IsDisabled = true;
        else delete pdf.IsDisabled;
        return pdf;
      });

      return predefinedInputs.concat(this.InputTypes);
    },
    validateForm() {
      return !this.errors.any();
    },
  },
  data() {
    return {
      editorConfig: CKconfig.editorConfig,
      //---------------Dynamic form builder -----------------------------------------
      // mySourceFields: [
      //   { type: "text", icon: "text_format", label: "Text" },
      //   { type: "paragraph", icon: "text_fields", label: "Paragraph" },
      //   { type: "checkboxes", icon: "check_box", label: "Checkboxes" },
      //   { type: "radio", icon: "radio_button_checked", label: "Mult. Choice" },
      //   { type: "date", icon: "event", label: "Date" },
      //   { type: "time", icon: "access_time", label: "Time" },
      //   { type: "dropdown", icon: "arrow_drop_down", label: "Dropdown" },
      //   { type: "email", icon: "email", label: "Email" },
      //   //{ type: "name", icon: "person", label: "Name" },
      //   //{ type: "simple_name", icon: "person_outline", label: "Simple Name" },
      //   //{ type: "address", icon: "home", label: "Address" },
      //   { type: "phone", icon: "phone", label: "Phone" },
      //   { type: "file", icon: "cloud_upload", label: "File Upload" },
      //   //{ type: "payment", icon: "payment", label: "Payment" },
      //   //{ type: "terms", icon: "ballot", label: "Terms" },
      //   //{ type: "" },
      //   //{ type: "" },
      //   //{ type: "" },
      //   //{ type: "section_break", icon: "view_agenda", label: "Section Break" },
      //   //{ type: "page_break", icon: "call_to_action", label: "Page Break" }
      // ],
      //----------------------------------------------------------------------
      FileUploadFormats: [".jpg", ".jpeg", ".png", ".webp", ".pdf", ".doc"],
      FileUploadCategory: ["Voter", "Aadhaar", "Resume", "Profile Picture", "Certificate", "Id Proof","Photo"],
      FormTitle: "Registration Form",
      FormType: "Free",
      RegistrationTypes: [],
      TicketList: [],
      SubmitButtonDisplaylabel: "Form Submit",
      LandingPageShowEventListLink: true,
      LandingPageShowHostedByPanel: true,
      PayingTo: "E2M",
      PayingToLogo:
        "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2Fon-air-white.png?alt=media",
      //------ LOGO update---------
      activeWizard: 0,

      //---------------------------------------
      predefinedInputs: [
        { Name: "Salutation", Value: "Salutation", InputType: "radio" },
        { Name: "Company", Value: "Company", InputType: "text" },
        { Name: "Designation", Value: "Designation", InputType: "text" },
        { Name: "Phone", Value: "phone" },
        // { Name: "Profile Picture", Value: "profilepicture" },
        { Name: "Address", Value: "Address", InputType: "textarea" },
        { Name: "City", Value: "City", InputType: "text" },
        { Name: "Zip", Value: "Zip", InputType: "text" },
        { Name: "Country & State", Value: "country&state" },
        { Name: "Group Title", Value: "group_title" },
        { Name: "group Sub-title", Value: "group_subtitle" },
      ],
      InputTypes: [
        { Name: "Emailbox", Value: "email" },
        { Name: "Textbox", Value: "text" },
        { Name: "Number", Value: "number" },
        { Name: "Big Textbox", Value: "textarea" },
        { Name: "Radio Button", Value: "radio" },
        { Name: "Single Checkbox", Value: "checkbox" },
        { Name: "Single Dropdown", Value: "select" },
        { Name: "Multiselect Dropdown", Value: "multiselect" },
         { Name: "File",Value: "file" },
         
      ],
      DefaultFields: [
        {
          Type: "text",
          Name: "FirstName",
          Label: "First Name",
          PlaceHolder: "Enter First Name",
          Order: 1,
          ColumnSize: 6,
          Mandatory: true,
          Compare: false,
          StaticField: true,
          Options: [],
          value: null,
          ShowInVisitor: true,
        },
        {
          Type: "text",
          Name: "LastName",
          Label: "Last Name",
          PlaceHolder: "Enter Last Name",
          Order: 2,
          ColumnSize: 6,
          Mandatory: true,
          Compare: false,
          StaticField: true,
          Options: [],
          value: null,
          ShowInVisitor: true,
        },
        {
          Type: "email",
          Name: "Email",
          Label: "Email Address",
          PlaceHolder: "Enter Your Email",
          Order: 3,
          ColumnSize: 12,
          Mandatory: true,
          Compare: false,
          StaticField: true,
          Options: [],
          value: null,
          ShowInVisitor: true,
        },
      ],

      PreSignupFields: {
        HTMLbody:
          "<p style='text-align: justify;'><strong>By accepting the submit button, you agree to the below terms and conditions</strong> </p>  <p style='text-align: justify;'>I authorize to contact me through various marketing channels such as Email, WhatsApp, SMS and Calls during and before the event.</p><p style='text-align: justify;'>Rights of admission at the event is reserved and is at the sole discretion of the management.</p>",
        RequireAcceptance: true,
        AcceptanceValidationDisplayLabel: "Please accept terms and conditions.",
        AcceptanceDisplayText: "I Accept",
        OptInOne: "Get important updates on WhatsApp, email, and SMS",
        OptInOneIsRequired: false,
        OptInTwo:
          "We may share your name and email address with sponsors whose booths you visit. Please check this box if you would like to be excluded from these lists.",
        OptInTwoIsRequired: false,
      },
      DynamicFields: [],
      FieldsType: "Basic",
    };
  },
  watch: {},
  methods: {
    setColumnSizeFixed(field){
      if(field.Compare)
        field.ColumnSize = 6;
    },
    setFieldName(field, index) {     
      let isdefaultfield = this.predefinedInputs.some(
        (pdf) => pdf.Value == field.Type
      );
      if (!field.StaticField && !isdefaultfield) {
        //field.Name = field.Label ? field.Label.trim().replace(/ +/g, "") : null;
        let Name = field.Label ? field.Label.trim().replace(/ +/g, "") : null;
        if(field.Label && field.Name == Name) return false;
        if(Name) field.Name = this.createFieldName(Name, index);
        else field.Name = null;
      }
    },
    createFieldName(Name, findex){
      let i = 0;
      for(let [key, f] of this.DefaultFields.entries()){
        if(f.Name == Name && key != findex){
          i++;
          Name = i > 0 ? `${Name}_${i}` : Name;
          this.createFieldName(Name, findex);
        }
      }      
      return Name;
    },
    getAllRegistrationTypes() {
      this.$store
        .dispatch("TicketManagement/fetchRegistrationTypes")
        .then((tickets) => {
          this.TicketList = tickets.map((item) => {
            if (item.Status != "Closed" && item.IsPublished) {
              return {
                ColorCode: item.ColorCode,
                Currency: item.Currency,
                FormType: item.FormType,
                Price: item.Price,
                RegistrationType: item.RegistrationType,
                RegistrationTypeId: item.RegistrationTypeId,
              };
            }
          });
        });
    },
    addRow(index) {
      let rowObj = {
        Type: "text",
        Name: null,
        Label: null,
        PlaceHolder: null,
        Order: 4,
        ColumnSize: 6,
        Mandatory: false,
        Compare: false,
        Options: [],
        value: null,
        ShowInVisitor: false,
      };
      //this.DefaultFields.splice(Number(index+1), 0, rowObj);
      this.DefaultFields.push(rowObj);
    },
    setFieldType(field, findex) {
      delete this.DefaultFields[findex]["Country"];
      delete this.DefaultFields[findex]["State"];
      delete this.DefaultFields[findex]["PhoneCountryCode"];
      delete this.DefaultFields[findex]["IsPredefined"];
      delete this.DefaultFields[findex]["InputType"];
      this.DefaultFields[findex]["Label"] = null;
      field.Name = null;
      if (field.Type == "country&state") {
        field.IsPredefined = true;
        this.DefaultFields[findex]["Country"] = null;
        this.DefaultFields[findex]["State"] = null;
      } else if (field.Type == "profilepicture") {
        field.IsPredefined = true;
        field.Name = "ProfilePictureURL";
      } else if (field.Type == "phone") {
        field.IsPredefined = true;
        this.DefaultFields[findex]["PhoneCountryCode"] = null;
        field.Name = "Phone";
      } else {
        let pfield = this.predefinedInputs.find(
          (pdf) => pdf.Value == field.Type
        );
        if (pfield) {
          field.Name = pfield.Value;
          field.IsPredefined = true;
          if (pfield.InputType) field.InputType = pfield.InputType;
        }
      }
    },
    getCheckoutForm() {
      let FormId = this.$route.params.FormId ? this.$route.params.FormId : null;
      if (FormId) {
        this.$vs.loading();
        this.$store
          .dispatch("TicketManagement/fetchCheckoutForm", FormId)
          .then((res) => {
            //console.log(res)
            this.$vs.loading.close();
            this.FormTitle = res.data.FormTitle;
            /*this.SubmitButtonDisplaylabel = res.data.SubmitButtonDisplaylabel,
          this.LandingPageShowEventListLink = res.data.LandingPageShowEventListLink,
          this.LandingPageShowHostedByPanel = res.data.LandingPageShowHostedByPanel,
          this.PayingTo = res.data.PayingTo,
          this.PayingToLogo = res.data.PayingToLogo,*/
            this.RegistrationTypes = res.data.RegistrationTypes
              ? res.data.RegistrationTypes
              : [];
            this.DefaultFields = res.data.DefaultFields;
            this.PreSignupFields = res.data.PreSignupFields;
            this.DynamicFields = res.data.DynamicFields;

            this.DefaultFields.filter((item) => {
              if (item.Type == "file") {
                if (item.Formats && item.Formats.length > 0) {
                  item.Formats = item.Formats.split(",");
                }
              }
            });
          });
      }
    },
    before_save() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll().then((result) => {
          if (result) resolve(result);
          else reject();
        });
      });
    },
    savePreview() {
      // this.before_save().then(_=>{
      //   this.SaveCheckoutForm(true);
      // })
      if (!this.validateForm) return;
      this.SaveCheckoutForm(true);
    },
    SaveCheckoutForm(preview = false) {
      if (!this.validateForm) return;
      this.$vs.loading();
      this.DefaultFields.filter((item, index) => {
        console.log("save item===", item);

        item.Order = index + 1;
        if (item.Type == "file") {
          if (item.Formats && item.Formats.length > 0) {
            item.Formats = item.Formats.toString();
            console.log("update item===", item.Formats);
          }
        }
      });
      let FormId = this.$route.params.FormId ? this.$route.params.FormId : null;
      if (FormId) {
        this.$store
          .dispatch("TicketManagement/updateCheckoutForm", {
            FormId: FormId,
            FormTitle: this.FormTitle,
            /*SubmitButtonDisplaylabel: this.SubmitButtonDisplaylabel,
          LandingPageShowEventListLink: this.LandingPageShowEventListLink,
          LandingPageShowHostedByPanel: this.LandingPageShowHostedByPanel,
          PayingTo: this.PayingTo,
          PayingToLogo: this.PayingToLogo,*/
            RegistrationTypes: this.RegistrationTypes,
            DefaultFields: this.DefaultFields,
            PreSignupFields: this.PreSignupFields,
            DynamicFields: this.DynamicFields,
          })
          .then((res) => {
            this.$vs.loading.close();
            if (res.status == 200) {
              this.$vs.notify({
                color: "success",
                position: "top-center",
                text: "Form Updated Successfully",
              });
              if (preview) {
                window.open(
                  `https://${ls.getSessionValueByKey(
                    "CustomDomain"
                  )}/eventv3/${ls.getSessionValueByKey("Session_Event_Id")}`,
                  "_blank"
                );
              }
              this.$router.push("/event/reg-dashboard?activeTab=1");
            } else {
              this.$vs.notify({
                color: "warning",
                position: "top-center",
                text: "Form not Updated",
              });
            }
          })
          .catch((err) => {
            this.$vs.loading.close();
            this.$vs.notify({
              color: "warning",
              position: "top-center",
              text: "Something went wrong!",
            });
          });
      } else {
        this.$store
          .dispatch("TicketManagement/addCheckoutForm", {
            FormTitle: this.FormTitle,
            /*SubmitButtonDisplaylabel: this.SubmitButtonDisplaylabel,
          LandingPageShowEventListLink: this.LandingPageShowEventListLink,
          LandingPageShowHostedByPanel: this.LandingPageShowHostedByPanel,
          PayingTo: this.PayingTo,
          PayingToLogo: this.PayingToLogo,*/
            RegistrationTypes: this.RegistrationTypes,
            DefaultFields: this.DefaultFields,
            PreSignupFields: this.PreSignupFields,
            DynamicFields: this.DynamicFields,
          })
          .then((res) => {
            this.$vs.loading.close();
            if (res.status == 200) {
              this.$vs.notify({
                color: "success",
                position: "top-center",
                text: "Form Added Successfully",
              });
              if (preview) {
                window.open(
                  `https://${ls.getSessionValueByKey(
                    "CustomDomain"
                  )}/eventv3/${ls.getSessionValueByKey("Session_Event_Id")}`,
                  "_blank"
                );
              }
              this.$router.push("/event/reg-dashboard?activeTab=1");
            } else {
              this.$vs.notify({
                color: "warning",
                position: "top-center",
                text: "Form not Added",
              });
            }
          })
          .catch((err) => {
            console.log(err);
            this.$vs.loading.close();
            this.$vs.notify({
              color: "warning",
              position: "top-center",
              text: "Something went wrong!",
            });
          });
      }
    },
  },

  created() {
    vm = this;
    if (!moduleTicketManagement.isRegistered) {
      this.$store.registerModule("TicketManagement", moduleTicketManagement);
      moduleTicketManagement.isRegistered = true;
    }
    this.getAllRegistrationTypes();
    this.getCheckoutForm();
  },
};
</script>